module.exports = __webpack_public_path__ + "static/img/Keano-Kini.e312303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Keano-Kini.jpg
// module id = UQ3y
// module chunks = 0